module.exports = __webpack_public_path__ + "static/funeral-7ee311b7228c8204faa5556136397af5.png";